import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";

import {
  fetchMusicLinksList,
  clearMusicLinksList,
  clearMusicLinkStatus,
  applyMusicLinksDrag,
  clearMusicLinksDrag,
  clearMusicLinkPatchStatus,
  deleteMusicLink,
  clearMusicLinkDeleteStatus,
  clearMediaSamplePatchStatus,
  clearMusicLinkSourceUpdateStatus,
  clearAddMusicServiceLink,
  clearPatchMusicServiceLink,
  clearDeleteMusicServiceLink,
} from 'redux/music-links/actions';

import { Loader } from 'semantic-ui-react';
import CommonMessage from 'components/common/CommonMessage';
import MusicLinkItem from 'components/dashboard/music-links-content/MusicLinkItem';
import LinksEmptyState from 'components/dashboard/links-content/LinksEmptyState';

import './MusicLinkItemsList.css';

class MusicLinkItemsList extends Component {
  static propTypes = {
    fetchMusicLinksList: PropTypes.func.isRequired,
    clearMusicLinkPatchStatus: PropTypes.func.isRequired,
    deleteMusicLink: PropTypes.func.isRequired,
    clearMusicLinkDeleteStatus: PropTypes.func.isRequired,
    clearMediaSamplePatchStatus: PropTypes.func.isRequired,
    clearMusicLinkSourceUpdateStatus: PropTypes.func.isRequired,
    clearAddMusicServiceLink: PropTypes.func.isRequired,
    clearPatchMusicServiceLink: PropTypes.func.isRequired,
    clearDeleteMusicServiceLink: PropTypes.func.isRequired,
    clearMusicLinksDrag: PropTypes.func.isRequired,
    clearMusicLinkStatus: PropTypes.func.isRequired,
    musicLinksList: PropTypes.object,
    musicLinksListError: PropTypes.object,
    musiclinkDragSuccess: PropTypes.object,
    musiclinkDragError: PropTypes.object,
    patchMusicLinkSuccess: PropTypes.object,
    patchMusicLinkError: PropTypes.object,
    addMusicServiceLinkSuccess: PropTypes.object,
    patchMusicServiceLinkSuccess: PropTypes.object,
    deleteMusicServiceLinkSuccess: PropTypes.object,
    patchMediaSampleSuccess: PropTypes.object,
    addMusicLinkSuccess: PropTypes.object,
    updateMusicLinkSourceSuccess: PropTypes.object,
  };

  static defaultProps = {
    musicLinksList: null,
    musicLinksListError: null,
    patchMusicLinkSuccess: null,
    patchMusicLinkError: null,
    addMusicServiceLinkSuccess: null,
    patchMusicServiceLinkSuccess: null,
    deleteMusicServiceLinkSuccess: null,
    patchMediaSampleSuccess: null,
    addMusicLinkSuccess: null,
    updateMusicLinkSourceSuccess: null,
  };

  state = {
    items: [],
    services: [],
  };

  componentDidMount() {
    if (!this.props.musicLinksList) {
      this.props.fetchMusicLinksList();
    } else {
      this.setState({
        items: this.props.musicLinksList && this.props.musicLinksList.links || [],
        services: this.props.musicLinksList && this.props.musicLinksList.services || [],
      });
    }
  }

  componentDidUpdate(prevProps) {

    // Set Current List
    if (prevProps.musicLinksList !== this.props.musicLinksList) {
      this.setState({
        items: this.props.musicLinksList && this.props.musicLinksList.links || [],
        services: this.props.musicLinksList && this.props.musicLinksList.services || [],
      });
    }

    // Drag and Drop
    if (
      !prevProps.musiclinkDragSuccess &&
      prevProps.musiclinkDragSuccess !== this.props.musiclinkDragSuccess
    ) {
      this.props.fetchMusicLinksList();
      this.props.clearMusicLinksDrag();
    }

    // Update list when new link is added | or when updates source
    if (
      (!prevProps.addMusicLinkSuccess &&
      prevProps.addMusicLinkSuccess !== this.props.addMusicLinkSuccess) ||
      (!prevProps.updateMusicLinkSourceSuccess &&
        prevProps.updateMusicLinkSourceSuccess !== this.props.updateMusicLinkSourceSuccess)
    ) {
      this.props.fetchMusicLinksList();
        this.props.clearMusicLinkStatus();
        this.props.clearMusicLinkSourceUpdateStatus();
    }

    // Patch
    if (
      (!prevProps.patchMusicLinkSuccess &&
      prevProps.patchMusicLinkSuccess !== this.props.patchMusicLinkSuccess) ||
      (!prevProps.patchMediaSampleSuccess &&
      prevProps.patchMediaSampleSuccess !== this.props.patchMediaSampleSuccess)
    ) {
      this.props.fetchMusicLinksList();
      this.props.clearMusicLinkPatchStatus();
      this.props.clearMediaSamplePatchStatus();
    }

    // Delete
    if (
      !prevProps.deleteMusicLinkSuccess &&
      prevProps.deleteMusicLinkSuccess !== this.props.deleteMusicLinkSuccess
    ) {
      this.props.fetchMusicLinksList();
      this.props.clearMusicLinkDeleteStatus();
    }

    // Add Music Service Link
    if (
      !prevProps.addMusicServiceLinkSuccess &&
      prevProps.addMusicServiceLinkSuccess !== this.props.addMusicServiceLinkSuccess
    ) {
      this.props.fetchMusicLinksList();
      this.props.clearAddMusicServiceLink();
    }

    // Patch Music Service Link
    if (
      !prevProps.patchMusicServiceLinkSuccess &&
      prevProps.patchMusicServiceLinkSuccess !== this.props.patchMusicServiceLinkSuccess
    ) {
      this.props.fetchMusicLinksList();
      this.props.clearPatchMusicServiceLink();
    }

    // Delete Music Service Link
    if (
      !prevProps.deleteMusicServiceLinkSuccess &&
      prevProps.deleteMusicServiceLinkSuccess !== this.props.deleteMusicServiceLinkSuccess
    ) {
      this.props.fetchMusicLinksList();
      this.props.clearDeleteMusicServiceLink();
    }
  }

  componentWillUnmount() {
    // this.props.clearMusicLinksList()
    this.props.clearMusicLinkStatus();
  }

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const items = this.reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({ items }, () => {
      const form = new FormData();
      this.state.items.map(item => item.id)
        .forEach(item => form.append('order', item));

      this.props.applyMusicLinksDrag(form);
    });
  };

  renderMusicLinksList = () => {
    const { patchMusicLinkSuccess, patchMusicLinkError, updateMusicLinkSourceSuccess } = this.props;
    const { items, services } = this.state;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable_music_links__section">
          {provided => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {items && items.map((item, index) => (
                <Draggable
                  key={`${item.id}`}
                  draggableId={`${item.id}`}
                  index={index}
                >
                  {provided => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <MusicLinkItem
                        musicLinkItem={item}
                        patchMusicLinkSuccess={patchMusicLinkSuccess}
                        updateMusicLinkSourceSuccess={updateMusicLinkSourceSuccess}
                        patchMusicLinkError={patchMusicLinkError}
                        musicServices={services}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  render() {
    const { musicLinksList, musicLinksListError } = this.props;
    const { items } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="music-link-items-list__component">
            {/* Loader */}
            {!musicLinksList && !musicLinksListError &&
              <Loader active />
            }

            {/* Links List */}
            {items && items.length > 0 &&
              this.renderMusicLinksList()
            }
            {items && items.length === 0 &&
              <LinksEmptyState
                text={
                  <>
                    <div>{t("Paste")}</div>
                    <div><strong>{t("your first music")}</strong></div>
                    <div><strong>{t("link")}</strong> {t("here")}</div>
                  </>
                }
              />
            }

            {/* Fetch Links Error */}
            {musicLinksListError &&
              <CommonMessage
                error
                errors={musicLinksListError}
              />
            }
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    musicLinksList: state.musicLinksReducer.musicLinksList,
    musicLinksListError: state.musicLinksReducer.musicLinksListError,
    addMusicLinkSuccess: state.musicLinksReducer.addMusicLinkSuccess,
    addMusicLinkError: state.musicLinksReducer.addMusicLinkError,
    patchMusicLinkSuccess: state.musicLinksReducer.patchMusicLinkSuccess,
    patchMusicLinkError: state.musicLinksReducer.patchMusicLinkError,
    musiclinkDragSuccess: state.musicLinksReducer.musiclinkDragSuccess,
    musiclinkDragError: state.musicLinksReducer.musiclinkDragError,
    deleteMusicLinkSuccess: state.musicLinksReducer.deleteMusicLinkSuccess,
    deleteMusicLinkError: state.musicLinksReducer.deleteMusicLinkError,
    patchMediaSampleSuccess: state.musicLinksReducer.patchMediaSampleSuccess,
    patchMediaSampleError: state.musicLinksReducer.patchMediaSampleError,
    updateMusicLinkSourceSuccess: state.musicLinksReducer.updateMusicLinkSourceSuccess,
    updateMusicLinkSourceError: state.musicLinksReducer.updateMusicLinkSourceError,
    addMusicServiceLinkSuccess: state.musicLinksReducer.addMusicServiceLinkSuccess,
    patchMusicServiceLinkSuccess: state.musicLinksReducer.patchMusicServiceLinkSuccess,
    deleteMusicServiceLinkSuccess: state.musicLinksReducer.deleteMusicServiceLinkSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMusicLinksList,
    clearMusicLinksList,
    clearMusicLinkStatus,
    applyMusicLinksDrag,
    clearMusicLinksDrag,
    clearMusicLinkPatchStatus,
    deleteMusicLink,
    clearMusicLinkDeleteStatus,
    clearMediaSamplePatchStatus,
    clearMusicLinkSourceUpdateStatus,
    clearAddMusicServiceLink,
    clearPatchMusicServiceLink,
    clearDeleteMusicServiceLink,
  },
)(MusicLinkItemsList);
